import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { icons } from '../../../assets/icons';
import './index.scss';
import { useDispatch } from 'react-redux';
import { getClaimByIdAdmin, updateClaimStatus } from '../../../api/redux/slices/Admin';
import { LoaderComponent } from '../../../helpers/components/loader';
import { convertDate } from '../../../helpers/modules';
import { ButtonComponent } from '../../../components/buttons';
import { showToast } from '../../../components/modal/index';

const ComplainDetails = () => {
	const dispatch = useDispatch();
	const params = useParams();
	const [detailComplain, setDetailComplain] = useState(null);
	const [loading, setLoading] = useState(false);
	const [isloading, setIsLoading] = useState(false);

	const token = localStorage.getItem('accesstoken');
	const [selectedStatus, setSelectedStatus] = useState(false);
	const navigate = useNavigate();

	//----------------------- GET CLAIM BY ID ---------------------------//
	useEffect(() => {
		setLoading(true);
		dispatch(
			getClaimByIdAdmin({
				token: token,
				id: params.id,
			}),
		)
			.unwrap()
			.then((res) => {
				console.log('Full response:', res);
				console.log('Claim details:', res.data);
				console.log('Created by:', res.data?.created_by);
				setDetailComplain(res.data);
				setSelectedStatus(res.data?.status || false);
			})
			.catch((err) => {
				console.error('Error fetching claim:', err);
				showToast('Erreur lors du chargement', 'error');
			})
			.finally(() => setLoading(false));
	}, [dispatch, params, token]);

	const updateClaim = () => {
		setIsLoading(true);
		dispatch(
			updateClaimStatus({
				token: token,
				id: params.id,
				status: selectedStatus,
			}),
		)
			.unwrap()
			.then(() => {
				showToast('Statut mis à jour', 'success');
				setTimeout(() => {
					navigate(`/admin/complaints/${params.page}`);
				}, 1000);
			})
			.catch((err) => {
				showToast(err?.message || 'Erreur lors de la mise à jour', 'error');
			})
			.finally(() => setIsLoading(false));
	};

	if (loading) return <LoaderComponent />;
	
	if (!detailComplain) return <div>Chargement...</div>;

	return (
		<div id='complainDetails'>
			<div id='details-complain-header'>
				<Link to={`/admin/complaints/${params.page}`}>
					<icons.BsArrowLeft style={{ color: '#5B5B5B', marginRight: '10px' }} />
					<h1>Listes des reclamations</h1>
				</Link>
			</div>
			<div id='headComplain'>
				<div className='c-line'>
					<h2>Date: </h2>
					<span>{convertDate(detailComplain?.createdAt || detailComplain?.created_at, 'DD-MM-YYYY')}</span>
				</div>
				<div className='c-line'>
					<h2>Client: </h2>
					<span>{detailComplain?.created_by || '-'} </span>
				</div>
				<div className='c-line'>
					<h2>Société: </h2>
					<span>{detailComplain?.company || '-'}</span>
				</div>
				<div className='c-line'>
					<h2>Email:</h2>
					<span>{detailComplain?.email || '-'}</span>
				</div>
				<div className='c-line'>
					<h2>Téléphone:</h2>
					<span>{detailComplain?.phone || '-'}</span>
				</div>
			</div>
			
			<div id='object'>
				<h2>Objet de la réclamation</h2>
				<span>{detailComplain?.object?.name || detailComplain?.type?.name || detailComplain?.object || '-'}</span>
			</div>
			
			<div id='message-complain'>
				<h2>Message</h2>
				<p>{detailComplain?.message || '-'}</p>
			</div>
			
			<div id='statut-complain'>
				<h2>Statut de la réclamation</h2>
				<div id='radio-status'>
					<label>
						<input
							type='radio'
							checked={selectedStatus === false}
							onChange={() => setSelectedStatus(false)}
						/>
						En cours
					</label>
					<label>
						<input
							type='radio'
							checked={selectedStatus === true}
							onChange={() => setSelectedStatus(true)}
						/>
						Traité
					</label>
				</div>
			</div>
			<ButtonComponent
				name={'Enregistrer'}
				loading={isloading}
				type={'button'}
				className={'button-primary'}
				onClick={updateClaim}
			/>
		</div>
	);
};

export default ComplainDetails;